<template>
  <div>
    <batch-add-card :config="edit" @success="updateData"></batch-add-card>
  </div>
</template>
<script>
import batchAddCard from "../../../components/batchAddCard";
export default {
  components: {
    batchAddCard,
  },
  data() {
    return {
      edit: {
        type: "other",
        fileType: {
          1: ".xlsx",
        },
        form: {},
        request: "/admin/merchant/product/createDiscountProductByExcel",
        title: this.language("scrapProducts.step2Title"),
        setp1: {
          temUrl: "/sis_cms/file/SIS-DamagedProductsUpload.xlsx",
          title: this.language("productInventory.step") + "1",
          text: this.language("scrapProducts.editStep1Text"),
          button: this.language("productInventory.download"),
        },
        setp2: {
          title: this.language("productInventory.step") + "2",
          text: this.language("scrapProducts.editStep2Text"),
          formName: "file",
        },
        stepButton: this.language("scrapProducts.stepButton"),
      },
    };
  },
  methods: {
    updateData(e) {
      this.$alert("待「一本」批核", "提示", {
        confirmButtonText: "確認",
        callback: (action) => {
          this.$message.success(this.language("scrapProducts.success"));
          this.$emit("success", e);
        },
      });
    },
  },
};
</script>